import { useEffect, useMemo } from "react";
import "./index.less";
import { useSearchParams } from "react-router-dom";
import { trackGdp } from "@/utils/gio-report";
import { getChannel } from "@/utils/tools";

// 活动详情  打榜使用
const ActivityDetailPage = () => {
  const [searchParams] = useSearchParams();

  const desc = useMemo(() => {
    const rawValue = searchParams.get("activityDescribe") || ""; // 用空字符串兜底
    try {
      return rawValue ? JSON.parse(rawValue) : "";
    } catch {
      return ""; // 增加JSON解析异常保护
    }
  }, [searchParams]);

  const activityId = useMemo(
    () => searchParams.get("activityId"),
    [searchParams],
  );

  useEffect(() => {
    document.title = "活动详情";
    trackGdp("P20191", "B001", {
      trackName: "充电_营销专题页_页面访问",
      origin: getChannel(),
      activityId: activityId,
    });
  }, []);

  return (
    <div className="activityDetail">
      <div className="desc">
        {desc?.split("\n")?.map((line, index) => (
          <div
            key={index}
            style={{
              textAlign: "justify", // 启用两端对齐
              textJustify: "inter-character", // 优化中文对齐
              wordBreak: "break-all", // 强制长单词换行
              maxWidth: "100%", // 固定容器宽度（按需调整）
              margin: "0 auto", // 居中显示（可选）
            }}
          >
            {line}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ActivityDetailPage;
